import React, { useState, useEffect } from 'react'

import ExperienceCard from '../ExperienceCard/ExperienceCard'
import ExperienceList from '../ExperienceList/ExperienceList'

import { getScheduleExperience } from '../../services/FirebaseServices/experienceServices'

const ExperienceComponent = ({ ...props }) => {
  const { experience, isMock, experiencesModel, slugAgency, experiencesData } =
    props

  const [isOpen, setIsOpen] = useState(false)

  const { category, key: experienceId, agencyKey: agencyId } = experience
  useEffect(() => {
    if (category === 'RESTAURANT') {
      handleSchedule()
    }
  }, [])

  const handleSchedule = async () => {
    if (isMock) {
      setIsOpen(true)
    } else {
      const scheduleResponse = await getScheduleExperience(
        agencyId,
        experienceId,
      )
      const { days } = scheduleResponse

      const currentDay = new Date().getDay()

      const schedule = days.find((item) => item.day === currentDay)

      const { openHour, closeHour } = schedule

      if (closeHour && openHour) {
        //Obtener si la hora es AM o PM
        const openHourPeriod = openHour.slice(-2)
        const closeHourPeriod = closeHour.slice(-2)

        const formatOpenHour =
          openHourPeriod === 'AM'
            ? parseInt(openHour.split(':')[0])
            : parseInt(openHour.split(':')[0]) + 12

        const formatOpenMinutes = parseInt(openHour.split(':')[1])

        const formatCloseHour =
          closeHourPeriod === 'AM'
            ? parseInt(closeHour.split(':')[0])
            : parseInt(closeHour.split(':')[0]) + 12

        const formatCloseMinutes = parseInt(closeHour.split(':')[1])

        const currentDate = new Date()
        const currentHour = currentDate.getHours()
        const currentMinutes = currentDate.getMinutes()

        if (
          (currentHour >= formatOpenHour ||
            (currentHour === formatOpenHour &&
              currentMinutes >= formatOpenMinutes)) &&
          (currentHour < formatCloseHour ||
            (currentHour === formatCloseHour &&
              currentMinutes < formatCloseMinutes))
        ) {
          setIsOpen(true)
        } else {
          setIsOpen(false)
        }
      }
    }
  }

  const handleExperienceComponent = () => {
    switch (experiencesModel) {
      case 1:
        return (
          <ExperienceCard
            slugAgency={slugAgency}
            experience={experience}
            isMock={isMock}
            isOpen={isOpen}
          />
        )
      case 2:
        return (
          <ExperienceList
            experience={experience}
            isMock={isMock}
            isOpen={isOpen}
          />
        )
      default:
        return (
          <ExperienceCard
            slugAgency={slugAgency}
            experience={experience}
            isMock={isMock}
            isOpen={isOpen}
          />
        )
    }
  }

  return <>{handleExperienceComponent()}</>
}

export default ExperienceComponent
